module.exports = __webpack_public_path__ + "files/050aeb6ccc080139866c91ecf0175442.svg";